import { useEffect, useState } from 'react'
import { getReportDropTeamsAPI } from '../../services/dropdown'

function UseReportDropTeams(orgId, groupId, dmId) {
  const [options, setOptions] = useState([])
  const [rawData, setRawData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      setLoading(true)
      try {
        const params = { orgId }
        if (groupId) params.groupId = groupId
        if (dmId) params.dmId = dmId
        const resp = await getReportDropTeamsAPI(params)
        if (!resp) return
        if (resp.status) {
          setRawData(resp.result)
          const newData = resp.result.map((d) => ({
            value: d?.teamId,
            label: d?.teamName
          }))
          setOptions(newData)
        } else {
          setOptions([])
          setRawData([])
        }
      } finally {
        setLoading(false)
      }
    }

    if (orgId) {
      getData()
    }
  }, [orgId, groupId, dmId])

  return { options, rawData, loading }
}

export default UseReportDropTeams
